var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MultiselectForm',_vm._b({staticClass:"war-room-edit-profile-form-product-types",attrs:{"autocomplete-items":_vm.productTypes,"create-handler":_vm.createProductType,"action-key-up":"enter"},on:{"change":function($event){return _vm.$emit('change', $event)}}},'MultiselectForm',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }